import React, { FC } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { APP_INFO_EMAIL } from '../../constants/links.constants';

import {
  Text,
  Flex,
  Popover,
  PopoverTrigger,
  PopoverArrow,
  PopoverContent,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  Button,
} from '@chakra-ui/react';
import { PX_APP_LAYOUT } from '../../assets/themes/base/space';
interface FooterProps {}

const Footer: FC<FooterProps> = (props) => {
  return (
    <>
      <Flex
        align='center'
        justify={'center'}
        direction={'column'}
        h={'fit-content'}
        w='100%'
        bg='background.light'
        gap={2}
        py={2}
        px={PX_APP_LAYOUT}
      >
        <Flex
          gap={1}
          direction={'row'}
          align='center'
          justify='center'
          flexWrap='wrap'
        >
          <Popover>
            <PopoverTrigger>
              <Button variant='footerLink' size='sm'>
                Contact Us
              </Button>
            </PopoverTrigger>
            <PopoverContent>
              <PopoverArrow />
              <PopoverCloseButton />
              <PopoverHeader fontWeight='normal'>Contact Us</PopoverHeader>
              <PopoverBody>
                <Text fontWeight='normal'>
                  Reach us at{' '}
                  <Button variant='link'>
                    <ReactRouterLink to='mailto:info@pokercity.com'>
                      {APP_INFO_EMAIL}
                    </ReactRouterLink>
                  </Button>{' '}
                  and we will get back to you shortly!
                </Text>
              </PopoverBody>
            </PopoverContent>
          </Popover>
          <Button variant='footerLink' size='sm'>
            <ReactRouterLink to='/terms'>
              Terms of Service
            </ReactRouterLink>
          </Button>
          <Button variant='footerLink' size='sm'>
            <ReactRouterLink to='/privacy-policy'>
              Privacy Policy
            </ReactRouterLink>
          </Button>
        </Flex>

        <Flex direction={'row'} align='center'>
          <Text
            fontWeight={'normal'}
            fontSize={['xs', 'sm']}
            color={'text.primary'}
          >
            &copy; {new Date().getFullYear()} PokerCity. All rights reserved.
          </Text>
        </Flex>
      </Flex>
    </>
  );
};
export default Footer;
